import { ca4kInstances, userTypes } from './constants';
import { OrgPermissions } from './permissions';

export const hasModules = (org, keys) => {
    if (!org?.modules?.length) return false;

    const keyArray = Array.isArray(keys) ? keys : [keys];
    return keyArray.some(key => org.modules.includes(key));
};

// Managed AG/TS editing needs the NEW CA4K REST API, which every sage-* VM
// runs — not just the first one. Keep this a membership test so adding another
// new-generation instance does not silently disable the UI for its orgs.
export const managedAgTsInstances = [ca4kInstances.SAGE, ca4kInstances.SAGE_1];

export const supportsManagedAgTs = org =>
    managedAgTsInstances.includes(org?.ca4k_instance);

export const canManageAgTs = (org, userData, hasPermission) =>
    userData?.type === userTypes.SUPER_ADMIN ||
    (hasPermission(OrgPermissions.MANAGE_ACCESS_CONTROL) &&
        org?.manage_ag_ts_enabled === true &&
        supportsManagedAgTs(org));
